module.exports = __webpack_public_path__ + "img/ocean-resort.e6edf332.jpg";